// extracted by mini-css-extract-plugin
export default {"search":"CustomerSelect_search__l0Ur3","customerType":"CustomerSelect_customerType__8KSry","form":"CustomerSelect_form__d0XC1"};